import React from 'react';
import PropTypes from 'prop-types';
import { Converter } from 'showdown';
import loadable from '@loadable/component';

import { prop } from 'src/utils';
import { Card, Title, Content, ALinkButton } from '../atoms';
const FAIcon = loadable(() => import('../atoms/FAIcon'));

const classMap = {
  p: 'mt-2 text-sm font-light text-gray-600',
  strong: 'text-gray-800',
  a: 'text-blue-600 underline hover:text-blue-700',
};

const bindings = Object.keys(classMap).map((key) => ({
  type: 'output',
  regex: new RegExp(`<${key}(.*)>`, 'g'),
  replace: `<${key} class="${classMap[key]}" $1>`,
}));

const converter = new Converter({
  extensions: [...bindings],
});

function Icon({ type, name, color }) {
  return (
    <div
      className={`w-20 h-24 flex items-center justify-center bg-${color}-200 transform rotate-45`}
      style={{ borderRadius: 200 }}
    >
      <FAIcon type={type} name={name} className={`text-3xl w-8 text-${color}-800 transform -rotate-45`} />
    </div>
  );
}

Icon.propTypes = {
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};

const getPublicURL = prop('publicURL');

export function IconCard({ url, file, external, button, icon, title, content }) {
  const linkUrl = url || getPublicURL(file);
  const showButton = !!button && !!linkUrl;

  return (
    <Card external={external} url={!showButton ? linkUrl : null}>
      <Icon type={icon ? icon.type : 'light'} name={icon ? icon.name : 'unlink'} color={icon ? icon.color : 'gray'} />
      <Title.Xs className="mt-3 text-center">{title}</Title.Xs>
      {!!content && (
        <Content converter={converter} className="w-full">
          {content}
        </Content>
      )}
      {!!showButton && (
        <ALinkButton external={external} url={linkUrl} className="mt-6">
          {button}
        </ALinkButton>
      )}
    </Card>
  );
}

IconCard.propTypes = {
  url: PropTypes.string,
  file: PropTypes.shape({
    publicURL: PropTypes.string.isRequired,
  }),
  external: PropTypes.bool,
  button: PropTypes.string,
  icon: PropTypes.shape({
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
  }).isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
};

IconCard.defaultProps = {
  url: null,
  file: null,
  external: false,
  button: null,
  content: null,
};
